/* ===============================================================================
   BAMBOOVE — TRANG COLLECTION: điều khiển thanh SORT/FILTERS (điện thoại)
   -------------------------------------------------------------------------------
   • FILE MỚI. Chỉ làm 3 việc, KHÔNG thay logic lọc/sắp xếp của Bamboove:
       1. Đo CHIỀU CAO HEADER thật → ghi vào biến `--bb-header-cao` để thanh dính
          ĐÚNG ngay dưới header (nếu header không dính ⇒ = 0 ⇒ dính sát mép trên).
       2. Bật class `.bamboove-bar--dinh` khi thanh đã dính (để hiện bóng).
       3. Không làm gì khi người dùng bật "giảm chuyển động".
   • Chạy được cả khi Bamboove đổi chiều cao header (resize / xoay máy / thanh địa chỉ
     di động co giãn) vì đo lại mỗi lần scroll/resize (rẻ: getBoundingClientRect).
   =============================================================================== */

(() => {
  const giamChuyenDong = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tìm LẠI mỗi lần chạy: Bamboove thay DOM vùng kết quả khi lọc/sắp xếp ⇒
  // phần tử thanh có thể bị dựng lại, không giữ tham chiếu cũ.
  const layThanh = () => document.querySelector('.bamboove-bar');
  const layHeader = () => document.querySelector('header');

  // --- 1. chiều cao header (chỉ tính khi header THẬT SỰ dính/fixed) ---
  const doHeader = () => {
    const header = layHeader();
    if (!header) return 0;
    const kieu = getComputedStyle(header).position;
    if (kieu !== 'sticky' && kieu !== 'fixed') return 0;
    return Math.round(header.getBoundingClientRect().height);
  };

  // --- 3. ĐỒNG BỘ số sản phẩm + bong bóng đếm lọc THEO HORIZON ---
  // Bamboove cập nhật kết quả bằng AJAX; thanh của mình có thể KHÔNG được dựng lại
  // ⇒ đọc thẳng từ thẻ đếm + bong bóng sẵn có của Bamboove để luôn khớp.
  /* ⚠️ GHI CÓ KIỂM TRA — đây là GỐC LỖI "chậm + giật" đo được 13/10/2026:
     `el.textContent = chu` LUÔN sinh mutation (xoá node cũ + thêm node mới) KỂ CẢ khi
     chữ y hệt. Mà `.bamboove-bar__dem` lại nằm TRONG `results-list` — đúng vùng
     `MutationObserver` ở cuối file theo dõi ⇒ mỗi vòng: ghi → observer bắn → `chay()`
     → `capNhat()` → ghi… thành VÒNG LẶP VÔ TẬN.
     SỐ ĐO: ngồi im 3 giây ⇒ 1.337 callback + `.bamboove-bar__dem` bị ghi 2.193 lần
     (≈445 lần/giây) ⇒ luồng chính bận liên tục: LỌC LÂU RA KẾT QUẢ + giao diện rung. */
  const datChu = (el, chu) => {
    if (el && el.textContent !== chu) el.textContent = chu;
  };

  const dongBo = () => {
    const thanh = layThanh();
    if (!thanh) return;

    const oDem = thanh.querySelector('.bamboove-bar__dem');
    if (oDem) {
      const nguon = document.querySelector('.products-count-wrapper [role="status"]');
      const so = nguon ? ((nguon.textContent || '').match(/([\d.,]+)/) || [])[1] : null;
      if (so) datChu(oDem, so + ' styles');
    }

    const oBong = thanh.querySelector('.bamboove-bar__bong');
    if (oBong) {
      const nguon = document.querySelector('#filters-drawer-bubble');
      const so = nguon && !nguon.hidden ? (nguon.textContent || '').trim() : '';
      datChu(oBong, so);
      const an = !so || so === '0';
      if (oBong.hidden !== an) oBong.hidden = an;
    }
  };

  // --- 4. ĐỒNG BỘ `sort_by` TRONG NGĂN KÉO theo địa chỉ hiện tại ---
  // Bamboove dựng URL sau khi lọc TỪ DỮ LIỆU FORM của ngăn kéo. Ngăn kéo có nhiều ô
  // `name="sort_by"` (select + 9 radio) mang giá trị CŨ ⇒ lọc xong là MẤT sắp xếp
  // (đã đo thật: `sort_by=title-ascending`). Cách đúng: KHÔNG tắt, mà **soi gương**
  // cho mọi ô `sort_by` = giá trị đang có trên URL.
  const dongBoSortNganKeo = () => {
    const dr = document.querySelector('#filters-drawer');
    if (!dr) return;
    const hienTai = new URL(window.location.href).searchParams.get('sort_by');
    if (!hienTai) return;
    dr.querySelectorAll('select[name="sort_by"]').forEach((s) => {
      if (s.value !== hienTai) s.value = hienTai;
    });
    dr.querySelectorAll('input[name="sort_by"]').forEach((i) => {
      i.checked = i.value === hienTai;
    });
  };

  // --- 5. CỘT LỌC (MÁY TÍNH): chỉ mở sẵn NHÓM "Size", gấp các nhóm còn lại ---
  // Vì sao: 5 nhóm mở hết ⇒ cột lọc cao ~2718px, đẩy lưới sản phẩm xuống (đo thật).
  // Bamboove KHÔNG có cài đặt này. Cách làm đúng theo code theme
  // (`assets/accordion-custom.js` dòng 96–103): trạng thái mở mặc định lấy từ thuộc
  // tính `open-by-default-on-desktop` ⇒ BỎ thuộc tính đó (và `open`) là component
  // không tự mở lại (kể cả khi đổi breakpoint). Số liệu vẫn còn nguyên trong DOM,
  // chỉ gấp lại — khách bấm vào là mở, thao tác lọc không đổi.
  // Đánh dấu `data-bb-gon` để KHÔNG giành quyền với khách: nhóm nào khách tự mở/đóng
  // rồi thì mình không can thiệp nữa.
  const NHOM_MO_SAN = 'Size'; // ← muốn mở sẵn nhóm khác thì đổi chữ ở đây
  const manHinhMayTinh = window.matchMedia('(min-width: 750px)');

  const gonCotLoc = () => {
    if (!manHinhMayTinh.matches) return;
    const cacNhom = [...document.querySelectorAll('.facets__item')].filter(
      (nhom) => !nhom.closest('#filters-drawer') && !nhom.closest('theme-drawer')
    );
    if (!cacNhom.length) return;

    const nhan = (nhom) => {
      const o = nhom.querySelector('.facets__label');
      return o ? o.textContent.trim() : '';
    };
    const nhomMoSan = cacNhom.find((nhom) => nhan(nhom) === NHOM_MO_SAN) || cacNhom[0];

    cacNhom.forEach((nhom) => {
      if (nhom.dataset.bbGon === '1') return;
      nhom.dataset.bbGon = '1';
      const mo = nhom === nhomMoSan;
      if (!mo) {
        nhom.removeAttribute('open');
        nhom.removeAttribute('open-by-default-on-desktop');
        nhom.removeAttribute('open-by-default-on-mobile');
      }
      const details = nhom.querySelector('details');
      if (details && details.open !== mo) details.open = mo;
    });
  };

  let dangDinh = null;
  const capNhat = () => {
    gonCotLoc();
    dongBoSortNganKeo();
    dongBo();
    const thanh = layThanh();
    if (!thanh) return;
    const mocTop = doHeader();
    const caoChu = mocTop + 'px';
    if (thanh.style.getPropertyValue('--bb-header-cao') !== caoChu) {
      thanh.style.setProperty('--bb-header-cao', caoChu);
    }

    if (giamChuyenDong) return;
    const dinh = thanh.getBoundingClientRect().top <= mocTop + 1;
    if (dinh !== dangDinh) {
      dangDinh = dinh;
      thanh.classList.toggle('bamboove-bar--dinh', dinh);
    }
  };

  let hen = 0;
  const chay = () => {
    if (hen) return;
    hen = requestAnimationFrame(() => {
      hen = 0;
      capNhat();
    });
  };

  capNhat();

  // capture=true: bắt được scroll của MỌI phần tử (Bamboove cuộn trong `.page-wrapper`)
  document.addEventListener('scroll', chay, { capture: true, passive: true });
  window.addEventListener('resize', chay, { passive: true });
  window.addEventListener('orientationchange', chay, { passive: true });
  window.addEventListener('load', chay, { once: true });

  // Bamboove cập nhật kết quả bằng JS ⇒ nghe thêm để đo lại
  document.addEventListener('shopify:section:load', chay);
  document.addEventListener('results-list:updated', chay);

  // Bamboove thay DOM vùng kết quả khi lọc/sắp xếp ⇒ sau mỗi lần thay, xử lý lại cột lọc
  const vungTheoDoi = document.querySelector('results-list') || document.body;
  let theoDoi = null;
  if (window.MutationObserver && vungTheoDoi) {
    // TẠM NGẮT theo dõi trong lúc mình GHI DOM, xong mới bật lại ⇒ không bao giờ
    // tự sinh vòng lặp từ chính thay đổi của mình (đo 13/10/2026: không có chốt này
    // thì thành ~445 lần/giây, xem ghi chú ở `datChu` phía trên).
    const batLai = () => {
      if (theoDoi && vungTheoDoi.isConnected) {
        theoDoi.observe(vungTheoDoi, { childList: true, subtree: true });
      }
    };
    theoDoi = new MutationObserver(() => {
      theoDoi.disconnect();
      chay();
      requestAnimationFrame(batLai);
    });
    batLai();
  }

  // --- 5. Ô SORT: mở/đóng popup + đổi sắp xếp bằng ĐIỀU HƯỚNG THẬT ---
  // Giữ NGUYÊN mọi tham số lọc đang có trên URL, chỉ thay `sort_by` ⇒ lưới luôn
  // được dựng lại đúng. (Đã ĐO THẬT: mượn component sort của Bamboove ở ngoài form
  // gốc thì URL đổi mà lưới KHÔNG vẽ lại.)
  const dongPop = (mo) => {
    const thanh = layThanh();
    if (!thanh) return;
    const pop = thanh.querySelector('.bamboove-bar__pop');
    const nut = thanh.querySelector('.bamboove-bar__nut');
    if (pop) pop.hidden = !mo;
    if (nut) nut.setAttribute('aria-expanded', mo ? 'true' : 'false');
  };

  document.addEventListener('click', (event) => {
    const thanh = layThanh();
    if (!thanh || !thanh.contains(event.target)) {
      dongPop(false);
      return;
    }

    const lua = event.target.closest('.bamboove-bar__lua');
    if (lua) {
      const giaTri = lua.getAttribute('data-bb-sort-by');
      if (giaTri) {
        const u = new URL(window.location.href);
        u.searchParams.set('sort_by', giaTri);
        window.location.assign(u.toString());
      }
      return;
    }

    const nut = event.target.closest('.bamboove-bar__nut');
    if (nut) {
      const pop = thanh.querySelector('.bamboove-bar__pop');
      dongPop(!!(pop && pop.hidden));
      return;
    }

    if (!event.target.closest('.bamboove-bar__o-sort')) dongPop(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dongPop(false);
  });
})();

